import { Trans } from "react-i18next";

import { TabType } from "../../atoms";
import { TabsType } from "./types";

export const DATE_ONLY_FORMAT = "DD MMM, yyyy";
export const USAGE_TIME_FORMAT = "hh:mm a";

export const TABS_USER_SESSIONS: TabType<TabsType>[] = [
  {
    id: "CURRENT",
    label: (
      <Trans i18nKey="page.userMember.tab.userSessions.creditPacksList.tabs.current" />
    ),
  },
  {
    id: "PREVIOUS",
    label: (
      <Trans i18nKey="page.userMember.tab.userSessions.creditPacksList.tabs.previous" />
    ),
  },
];
